import { zTooltipExt } from "src/common/attrEdit";
import { z } from "zod";

export const zTooltipExtFields = zTooltipExt.extend({
  text: z.string().nullable().optional(),
});
export type ZTooltipExtFields = z.infer<typeof zTooltipExtFields>;
